// Pocket lesson recordings are switched off for plain coaches - only the head coach has them.
// The Pocket code stays in the app and server; this one rule (and the matching check in the backend's routes/pocket.js)
// decides who sees it, so turning it back on for coaches means changing this line and that check.
export const pocketEnabledFor = (role) => role === 'headcoach';
